import React from 'react';
import { Typography } from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { resolvePatchApplyStatusViewModel } from './messagePatchApplyStatusModel.js';

const { Paragraph, Text } = Typography;

const STATUS_ICONS = {
  error: CloseCircleOutlined,
  muted: CloseCircleOutlined,
  pending: LoadingOutlined,
  success: CheckCircleOutlined,
  warning: ExclamationCircleOutlined,
};

function StatusIcon({ color, iconKind }) {
  const Icon = STATUS_ICONS[iconKind] || LoadingOutlined;
  return <Icon style={{ color }} />;
}

export function MessagePatchApplyStatusCard({
  item = {},
  themeTokens,
}) {
  const model = resolvePatchApplyStatusViewModel(item.payload);

  if (!model) {
    return null;
  }
  const tokens = Object.assign({}, themeTokens);
  const { color, iconKind, summary, title } = {
    color: '#2563eb', iconKind: 'pending', summary: '', title: '', ...model,
  };

  return (
    <div className="flare-message-patch-apply-status" data-tone={model.tone}>
      <div className="flare-message-patch-apply-status-title">
        <StatusIcon color={color} iconKind={iconKind} />
        <Text strong style={{ color: tokens.textPrimary }}>
          {title}
        </Text>
      </div>
      <Paragraph style={{ color: tokens.textSecondary, marginBottom: 0 }}>
        {summary}
      </Paragraph>
    </div>
  );
}

export default MessagePatchApplyStatusCard;
